<template>
    <div class="paypal-buttons">
        <div id="paypal-button-container"></div>
        <v-overlay v-if="!amount || disabled || loading" class="disabled-buttons-overlay select-none" color="surface" opacity="0.4" absolute></v-overlay>
    </div>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import Vue from 'vue'
const paypal = window.paypal;

/**
 * Renders PayPal Smart Buttons for a single recharge intent.
 *
 * The parent (Wallet.vue) is responsible for:
 *   - Creating a server-side recharge intent before mounting this component
 *   - Forcing a remount on intent change via `:key="paypalIntent.id"` so the
 *     createOrder closure captures the fresh intentId.
 *   - Locking the amount/promocode inputs while the popup is open (to prevent
 *     the user from changing the amount after createOrder is called for a stale
 *     intent — webhook would credit correctly but the UX would be confusing).
 */
export default {
    components: {},
    props: {
        amount: {},
        intentId: { type: String, required: true },
        disabled: {type: Boolean, default: false}
    },
    data(){
        return {
            paypalObject: null,
            loading: false,
        }
    },
    computed: {
        options(){
            const self = this,
                amount = this.amount,
                intentId = this.intentId;
            return {
                createOrder(data, actions) {
                    self.loading = true;
                    self.$emit('popup-open');
                    return actions.order.create({
                        intent: 'CAPTURE',
                        purchase_units: [
                            {
                                amount: { value: amount, currency_code: 'USD' },
                                custom_id: intentId,
                            },
                        ],
                        application_context: {
                            landing_page: 'BILLING',
                            brand_name: 'Riwaq Al Quran',
                            locale: 'en-US',
                            shipping_preference: 'NO_SHIPPING'
                        }
                    });
                },
                onApprove(data, actions) {
                    return actions.order.capture().then(response=>{
                        self.loading = false;
                        self.$emit('popup-close');
                        self.$emit('captured', response);
                    }).catch(e=>{
                        self.loading = false;
                        self.$emit('popup-close');
                        self.$emit('error', e);
                    });
                },
                onCancel(data) {
                    self.loading = false;
                    self.$emit('popup-close');
                },
                onError(err) {
                    self.loading = false;
                    self.$emit('popup-close');
                    self.$emit('error', err);
                },
            }
        },
        ...GlobalComputed
    },
    // The previous `watch: { amount() { this.paypalObject.updateProps(this.options); } }`
    // was the actual source of the closure-staleness risk — when the intent
    // changes, in-place updateProps left the OLD intentId baked into createOrder.
    // Parent now uses :key="paypalIntent.id" to force a clean remount instead.
    methods: {
        ...GlobalMethods,
    },
    mounted(){
        this.paypalObject = window.paypal.Buttons();
        this.paypalObject.updateProps(this.options);
        this.paypalObject.render('#paypal-button-container');
    }
};
</script>
<style lang="scss" scoped>
.paypal-buttons{
    position: relative;
    .disabled-buttons-overlay{
        z-index: 100!important;
    }
}
</style>
